import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function DeleteAccountPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-background/80 backdrop-blur-md sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} />
            Volver
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center">
              <span className="text-white font-bold text-sm">F</span>
            </div>
            <span className="text-lg font-bold text-foreground">Frappi</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-2">Eliminacion de Cuenta y Datos</h1>
        <p className="text-sm text-muted-foreground mb-8">
          Esta pagina describe como solicitar la eliminacion de tu cuenta de Frappi y de todos los datos asociados.
        </p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">Opcion 1: Eliminar tu cuenta desde la app</h2>
            <p className="text-muted-foreground leading-relaxed">
              Puedes eliminar tu cuenta directamente desde la aplicacion movil de Frappi:
            </p>
            <ol className="list-decimal list-inside text-muted-foreground space-y-1 mt-2">
              <li>Abre la app de Frappi e inicia sesion</li>
              <li>Ve a la pestana de <strong>Perfil</strong> y abre <strong>Ajustes</strong></li>
              <li>Selecciona <strong>Eliminar cuenta</strong></li>
              <li>Confirma con tu contrasena</li>
            </ol>
            <p className="text-muted-foreground leading-relaxed mt-2">
              La eliminacion es inmediata e irreversible.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">Opcion 2: Solicitar la eliminacion por correo</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si ya no tienes acceso a la app, envia un correo a{' '}
              <a href="mailto:totemgplay@gmail.com" className="text-primary hover:underline">
                totemgplay@gmail.com
              </a>{' '}
              desde la direccion de correo asociada a tu cuenta, con el asunto &quot;Eliminar mi cuenta&quot;.
              Procesaremos tu solicitud en un plazo maximo de 30 dias y te confirmaremos por correo cuando se complete.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">Datos que se eliminan</h2>
            <p className="text-muted-foreground leading-relaxed">
              Al eliminar tu cuenta se borran de forma permanente:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li>Tu informacion de cuenta (nombre, correo electronico y contrasena)</li>
              <li>Los perfiles de estudiantes que creaste (nombres, colegio, datos academicos)</li>
              <li>Tareas, calificaciones, eventos de calendario y planes de estudio</li>
              <li>Las imagenes que subiste para el escaneo con IA</li>
              <li>Tokens de notificaciones push asociados a tus dispositivos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">Datos que se conservan</h2>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li>
                <strong>Registros de facturacion:</strong> el historial de compras y suscripciones gestionado por
                Google Play se conserva segun las politicas de Google y los requisitos legales y fiscales aplicables.
              </li>
              <li>
                <strong>Copias de seguridad:</strong> los datos pueden permanecer en copias de seguridad internas
                hasta 30 dias despues de la eliminacion, tras lo cual se borran definitivamente.
              </li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Fuera de estos casos, no conservamos ningun dato personal despues de la eliminacion de la cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">Contacto</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si tienes preguntas sobre la eliminacion de tus datos, escribenos a{' '}
              <a href="mailto:totemgplay@gmail.com" className="text-primary hover:underline">
                totemgplay@gmail.com
              </a>
              . Tambien puedes consultar nuestra{' '}
              <Link to="/privacy" className="text-primary hover:underline">
                Politica de Privacidad
              </Link>
              .
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border py-8 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Frappi. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
